import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Sesión de administrador en cookie httpOnly: aquí no se guarda ningún token.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      // solo expulsamos si estamos dentro del panel de administración
      const adminPaths = ["/dashboard", "/solicitudes", "/conversaciones", "/subir",
        "/users", "/jobs", "/costs", "/audit", "/errors", "/admins"];
      const path = window.location.pathname;
      if (adminPaths.some((p) => path.startsWith(p))) window.location.href = "/admin";
    }
    return Promise.reject(err);
  }
);
